import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getViewedProductIds, VIEWED_PRODUCTS_EVENT } from '../utils/viewedProducts';

const useViewedProducts = () => {
  const productList = useSelector((state) => state.products.list);
  const [ids, setIds] = useState(getViewedProductIds);

  useEffect(() => {
    const refresh = () => setIds(getViewedProductIds());

    window.addEventListener(VIEWED_PRODUCTS_EVENT, refresh);
    window.addEventListener('storage', refresh);
    return () => {
      window.removeEventListener(VIEWED_PRODUCTS_EVENT, refresh);
      window.removeEventListener('storage', refresh);
    };
  }, []);

  return useMemo(() => {
    const byId = new Map(productList.map((product) => [Number(product.id), product]));
    return ids.map((id) => byId.get(id)).filter(Boolean);
  }, [ids, productList]);
};

export default useViewedProducts;
